import type { FC, ReactNode } from 'react';

type IProps = {
  children?: ReactNode;
};

const Container: FC<IProps> = ({ children }) => {
  return <div className="w-[1200px] my-0 mx-auto">{children}</div>;
};

export default Container;
